import { render, staticRenderFns } from "./ShippingPreview.vue?vue&type=template&id=0482c250"
import script from "./ShippingPreview.vue?vue&type=script&lang=js"
export * from "./ShippingPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports